
import { WorldCountry } from '../types';

export const turkeyExpanded2: WorldCountry = {
  name: 'Turkey',
  slug: 'turkey',
  code: 'TR',
  population: 84339067,
  topCities: [
    { name: 'Istanbul', slug: 'istanbul', population: 15519267 },
    { name: 'Ankara', slug: 'ankara', population: 5663322 },
    { name: 'Izmir', slug: 'izmir', population: 4394694 },
    { name: 'Bursa', slug: 'bursa', population: 3101833 },
    { name: 'Antalya', slug: 'antalya', population: 2619832 },
    { name: 'Adana', slug: 'adana', population: 2274106 },
    { name: 'Konya', slug: 'konya', population: 2232374 },
    { name: 'Gaziantep', slug: 'gaziantep', population: 2154051 },
    { name: 'Sanliurfa', slug: 'sanliurfa', population: 2115256 },
    { name: 'Mersin', slug: 'mersin', population: 1891145 },
    
    // Expansión: 90 ciudades adicionales
    { name: 'Kayseri', slug: 'kayseri', population: 1434357 },
    { name: 'Eskisehir', slug: 'eskisehir', population: 887475 },
    { name: 'Diyarbakir', slug: 'diyarbakir', population: 1783431 },
    { name: 'Samsun', slug: 'samsun', population: 1348542 },
    { name: 'Denizli', slug: 'denizli', population: 1037208 },
    { name: 'Adapazari', slug: 'adapazari', population: 1029650 },
    { name: 'Malatya', slug: 'malatya', population: 812580 },
    { name: 'Kahramanmaras', slug: 'kahramanmaras', population: 1177436 },
    { name: 'Erzurum', slug: 'erzurum', population: 762062 },
    { name: 'Van', slug: 'van', population: 1123784 },
    { name: 'Batman', slug: 'batman', population: 608659 },
    { name: 'Elazig', slug: 'elazig', population: 591598 },
    { name: 'Erzincan', slug: 'erzincan', population: 230354 },
    { name: 'Sivas', slug: 'sivas', population: 646608 },
    { name: 'Manisa', slug: 'manisa', population: 1440611 },
    { name: 'Tekirdag', slug: 'tekirdag', population: 1055412 },
    { name: 'Balıkesir', slug: 'balikesir', population: 1226575 },
    { name: 'Trabzon', slug: 'trabzon', population: 807903 },
    { name: 'Ordu', slug: 'ordu', population: 771932 },
    { name: 'Aydin', slug: 'aydin', population: 1119084 },
    { name: 'Usak', slug: 'usak', population: 370509 },
    { name: 'Isparta', slug: 'isparta', population: 441412 },
    { name: 'Afyon', slug: 'afyon', population: 737031 },
    { name: 'Kutahya', slug: 'kutahya', population: 579257 },
    { name: 'Canakkale', slug: 'canakkale', population: 540662 },
    { name: 'Kocaeli', slug: 'kocaeli', population: 1997258 },
    { name: 'Sakarya', slug: 'sakarya', population: 1042649 },
    { name: 'Bolu', slug: 'bolu', population: 320824 },
    { name: 'Yalova', slug: 'yalova', population: 276050 },
    { name: 'Zonguldak', slug: 'zonguldak', population: 596892 },
    { name: 'Karabuk', slug: 'karabuk', population: 248014 },
    { name: 'Bartin', slug: 'bartin', population: 198999 },
    { name: 'Kastamonu', slug: 'kastamonu', population: 383373 },
    { name: 'Sinop', slug: 'sinop', population: 216530 },
    { name: 'Corum', slug: 'corum', population: 536483 },
    { name: 'Amasya', slug: 'amasya', population: 335143 },
    { name: 'Tokat', slug: 'tokat', population: 593990 },
    { name: 'Giresun', slug: 'giresun', population: 448721 },
    { name: 'Gumushane', slug: 'gumushane', population: 151139 },
    { name: 'Bayburt', slug: 'bayburt', population: 82274 },
    { name: 'Artvin', slug: 'artvin', population: 168092 },
    { name: 'Rize', slug: 'rize', population: 344359 },
    { name: 'Kars', slug: 'kars', population: 288878 },
    { name: 'Igdir', slug: 'igdir', population: 201314 },
    { name: 'Ardahan', slug: 'ardahan', population: 95408 },
    { name: 'Agri', slug: 'agri', population: 536285 },
    { name: 'Mus', slug: 'mus', population: 408728 },
    { name: 'Bitlis', slug: 'bitlis', population: 349396 },
    { name: 'Bingol', slug: 'bingol', population: 281768 },
    { name: 'Tunceli', slug: 'tunceli', population: 86076 },
    { name: 'Hakkari', slug: 'hakkari', population: 287625 },
    { name: 'Sirnak', slug: 'sirnak', population: 546889 },
    { name: 'Mardin', slug: 'mardin', population: 854716 },
    { name: 'Siirt', slug: 'siirt', population: 331670 },
    { name: 'Adiyaman', slug: 'adiyaman', population: 635169 },
    { name: 'Kilis', slug: 'kilis', population: 142490 },
    { name: 'Osmaniye', slug: 'osmaniye', population: 559405 },
    { name: 'Hatay', slug: 'hatay', population: 1659320 },
    { name: 'Nigde', slug: 'nigde', population: 365419 },
    { name: 'Nevsehir', slug: 'nevsehir', population: 304647 },
    { name: 'Kirsehir', slug: 'kirsehir', population: 241868 },
    { name: 'Aksaray', slug: 'aksaray', population: 429069 },
    { name: 'Karaman', slug: 'karaman', population: 253279 },
    { name: 'Yozgat', slug: 'yozgat', population: 424981 },
    { name: 'Cankiri', slug: 'cankiri', population: 192428 },
    { name: 'Kirikkale', slug: 'kirikkale', population: 289258 },
    { name: 'Kirklareli', slug: 'kirklareli', population: 361836 },
    { name: 'Edirne', slug: 'edirne', population: 413903 },
    { name: 'Mugla', slug: 'mugla', population: 1000773 },
    { name: 'Burdur', slug: 'burdur', population: 271026 },
    { name: 'Anamas', slug: 'anamas', population: 45000 },
    { name: 'Bucak', slug: 'bucak', population: 65000 },
    { name: 'Golhisar', slug: 'golhisar', population: 25000 },
    { name: 'Tefenni', slug: 'tefenni', population: 15000 },
    { name: 'Cavdir', slug: 'cavdir', population: 8000 },
    { name: 'Yesilova', slug: 'yesilova', population: 12000 },
    { name: 'Karamanli', slug: 'karamanli', population: 18000 },
    { name: 'Celtikci', slug: 'celtikci', population: 6000 },
    { name: 'Altinyayla', slug: 'altinyayla', population: 8000 },
    { name: 'Aglasun', slug: 'aglasun', population: 15000 },
    { name: 'Kemer', slug: 'kemer-burdur', population: 8000 },
    { name: 'Fethiye', slug: 'fethiye', population: 175000 },
    { name: 'Marmaris', slug: 'marmaris', population: 95000 },
    { name: 'Bodrum', slug: 'bodrum', population: 180000 },
    { name: 'Milas', slug: 'milas', population: 75000 },
    { name: 'Ortaca', slug: 'ortaca', population: 55000 },
    { name: 'Dalaman', slug: 'dalaman', population: 45000 },
    { name: 'Koycegiz', slug: 'koycegiz', population: 35000 },
    { name: 'Seydikemer', slug: 'seydikemer', population: 25000 },
    { name: 'Ula', slug: 'ula', population: 18000 },
    { name: 'Mentese', slug: 'mentese', population: 22000 },
    { name: 'Yatagan', slug: 'yatagan', population: 35000 },
    { name: 'Kavaklidere', slug: 'kavaklidere', population: 15000 },
    { name: 'Datca', slug: 'datca', population: 18000 }
  ]
};
